module.exports = __webpack_public_path__ + "static/img/dn_img.e341ee9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dn_img.jpg
// module id = 45dk
// module chunks = 3